var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.241,
    height: 16.681,
    viewBox: "0 0 22.241 16.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.078,65.353c3.052,2.585,8.409,7.133,9.983,8.551a.93.93,0,0,0,1.345,0c1.576-1.419,6.932-5.968,9.984-8.553a.463.463,0,0,0,.065-.639A1.84,1.84,0,0,0,27,64H8.467a1.84,1.84,0,0,0-1.454.714A.463.463,0,0,0,7.078,65.353Z",
    transform: "translate(-6.613 -64)",
    fill: "#c6c9d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.972,126.455a.461.461,0,0,0-.494.067c-3.385,2.87-7.706,6.548-9.065,7.773a1.876,1.876,0,0,1-2.586,0c-1.449-1.305-6.3-5.43-9.064-7.772a.463.463,0,0,0-.763.353v11.653a1.855,1.855,0,0,0,1.853,1.853H20.388a1.855,1.855,0,0,0,1.853-1.853V126.875A.463.463,0,0,0,21.972,126.455Z",
    transform: "translate(0 -123.7)",
    fill: "#c6c9d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e2a62189bab56c233ff6ba237802fd7a.svg";
export { ForwardRef as ReactComponent };